
import * as actionTypes from '../actionTypes'
import * as constants from '../Constatnts'
import axios from 'axios'


export function saveExpenseCategories(Expense, key){
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key !== "") {
        // Update existing account
        response = await axios.put(
          `${constants.API_URL}/transaction/expense/category/${key}`,
          Expense,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // Create new account
        response = await axios.post(
          `${constants.API_URL}/transaction/expense/category`,
          Expense,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (response.data.code === "0") {
        if (key) {
          return key;
        } else {
          return response.data.data.key;
        }
      }

      return null;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}



export function deleteExpenseCategories(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.delete(
        constants.API_URL + `/transaction/expense/category/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code === "0") {
        return true;
      } else {
        alert(response.data.message || "Failed to delete categories");
        return false;
      }

    } catch (error) {
      alert("Failed to delete categories");
      return false;
    }
  };
}




export function getExpenseCategories(storeId) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        constants.API_URL + "/transaction/expense/category",
        {
          params: {
            storeID: storeId  
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      let categories = [];

      if (response.data.code === "0") {
        categories = (response.data.searchResult || []).filter(
          e => !e.IsDeleted
        );
      }

      return categories;

    } catch (error) {
      return [];
    }
  };
}



export function checkIfExpenseCategoriesIsUnique(ExpenseCategory, registrationID, storeID) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.post(
        `${constants.API_URL}/transaction/expense/category/unique`,
        {
          storeID,
          ExpenseCategory,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data.ExpenseIsUnique;
    }
    catch (error) {
      return [];
    }
  };
}

